module.exports = __webpack_public_path__ + "img/copyright.0c9c6294.jpg";